export default __webpack_public_path__ + "static/media/past-5-years.fc798c44.csv";